import React from 'react';
import { Link } from 'react-router-dom';
import Meander from '../ornament/Meander';
import ArtCredit from '../art/ArtCredit';

// The Dive Deep Dialogues policies cover every app in the family, this one
// included, so the legal links go there (the landing page's footer does the
// same). Crisis lines live on the Resources page, from the fleet's shared table.
const PRIVACY_URL = 'https://divedeepdialogues.com/privacy';
const TERMS_URL = 'https://divedeepdialogues.com/terms';

const Footer = () => {
  return (
    <footer className="bg-courtyard-stone text-courtyard-parchment/80 pb-8 mt-auto">
      <Meander height={12} className="text-courtyard-gold/60 mb-8" />
      <div className="max-w-6xl mx-auto px-4 text-center">
        <p className="text-sm text-courtyard-parchment/90">
          Finding Your Voice, part of the{' '}
          <a
            href="https://divedeepdialogues.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-courtyard-gold underline underline-offset-4 hover:text-courtyard-gold-light transition-colors"
          >
            Dive Deep Dialogues
          </a>{' '}
          family
        </p>
        <nav aria-label="Footer" className="mt-3 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm">
          <Link to="/resources" className="underline underline-offset-4 hover:text-courtyard-parchment">
            Resources and support lines
          </Link>
          <Link to="/profile#your-data" className="underline underline-offset-4 hover:text-courtyard-parchment">
            Your data
          </Link>
          <a href={PRIVACY_URL} className="underline underline-offset-4 hover:text-courtyard-parchment">
            Privacy Policy
          </a>
          <a href={TERMS_URL} className="underline underline-offset-4 hover:text-courtyard-parchment">
            Terms of Use
          </a>
        </nav>
        <p className="text-sm mt-4 text-courtyard-parchment/70">
          This is a learning app, not therapy or medical advice.
        </p>
        <ArtCredit className="text-sm mt-2 text-courtyard-parchment/70 max-w-2xl mx-auto" />
      </div>
    </footer>
  );
};

export default Footer;
